<template>

    <svg version="1.2"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         overflow="visible"
         preserveAspectRatio="none"
         viewBox="0 -7.000367917586459 53 53"
         width="18"
         height="18">
        <g><g xmlns:default="http://www.w3.org/2000/svg">
        <g>
            <path d="M25.1,20.5l6.2-4.7l4.1,4.1l1.4-1.4L33,14.6L48.2,3.3L48,19h2V3c0-1.7-1.2-3-2.8-3H3C1.4,0,0,1.4,0,3v27.3    C0,32,1.3,33,3,33h27v-2H3.8l15.1-15.2L25.1,20.5z M46.5,2L25.1,18L3.7,2H46.5z M2,29.9V3.3l15.2,11.3L2,29.9z M51.4,21.7    L41.1,35.8l-7.2-8.2L32.4,29l8.9,10L53,22.8L51.4,21.7z" style="fill: rgb(55, 164, 71);" vector-effect="non-scaling-stroke"/>
        </g>
        </g></g>
    </svg>
</template>

<script>
    export default {
        name: "GreenMailSVG"
    }
</script>

<style scoped>

</style>